import StorageUtil from "@/utils/storageUtil";
export default {
  setUser({ commit }, user) {
    // 提交一个comutation请求
    StorageUtil.saveUser(user);
    commit("SETUSER", { user }); // 传递给mutation的是一个包含数据的对象
  },
  setPageType({ commit }, pageType) {
    // 提交一个comutation请求
    StorageUtil.savePageType(pageType);
    commit("SETPAGETYPE", { pageType }); // 传递给mutation的是一个包含数据的对象
  },
  setVersion({ commit }, version) {
    // 提交一个comutation请求
    StorageUtil.saveVersion(version);
    commit("SETVERSION", { version }); // 传递给mutation的是一个包含数据的对象
  },
  setSourceType({ commit }, sourceType) {
    // 提交一个comutation请求
    StorageUtil.saveSourceType(sourceType);
    commit("SETSOURCETYPE", { sourceType }); // 传递给mutation的是一个包含数据的对象
  },
  setToken({ commit }, token) {
    // 提交一个comutation请求
    StorageUtil.saveToken(token);
    commit("SETTOKEN", { token }); // 传递给mutation的是一个包含数据的对象
  },
  setTokenCookie({ commit }, tokenCookie) {
    // 提交一个comutation请求
    StorageUtil.saveTokenCookie(tokenCookie);
    commit("SETTOKENCOOKIE", { tokenCookie }); // 传递给mutation的是一个包含数据的对象
  },
  setCustomerNumber({ commit }, customerNumber) {
    // 提交一个comutation请求
    StorageUtil.saveCustomerNumber(customerNumber);
    commit("SETCUSTOMERNUMBER", { customerNumber }); // 传递给mutation的是一个包含数据的对象
  },
  setAsterisk({ commit }, asterisk) {
    // 提交一个comutation请求
    StorageUtil.saveAsterisk(asterisk);
    commit("SETASTERISK", { asterisk }); // 传递给mutation的是一个包含数据的对象
  },
  setAccountNo({ commit }, accountNo) {
    // 提交一个comutation请求
    StorageUtil.saveAccountNo(accountNo);
    commit("SETACCOUNTNO", { accountNo }); // 传递给mutation的是一个包含数据的对象
  },
  setPlatform({ commit }, platform) {
    // 提交一个comutation请求
    StorageUtil.savePlatform(platform);
    commit("SETPLATFORM", { platform }); // 传递给mutation的是一个包含数据的对象
  },
  setPlatformName({ commit }, platformName) {
    // 提交一个comutation请求
    StorageUtil.savePlatformName(platformName);
    commit("SETPLATFORMNAME", { platformName }); // 传递给mutation的是一个包含数据的对象
  },
  setAccountInfo({ commit }, accountInfo) {
    // 提交一个comutation请求
    StorageUtil.saveAccountInfo(accountInfo);
    commit("SETACCOUNTINFO", { accountInfo }); // 传递给mutation的是一个包含数据的对象
  },
  setCurrency({ commit }, currency) {
    // 提交一个comutation请求
    StorageUtil.saveCurrency(currency);
    commit("SETCURRENCY", { currency }); // 传递给mutation的是一个包含数据的对象
  },
  setRechargeData({ commit }, rechargeData) {
    // 提交一个comutation请求
    StorageUtil.saveRechargeData(rechargeData);
    commit("SETRECHAREDATA", { rechargeData }); // 传递给mutation的是一个包含数据的对象
  },
  setWithdrawalData({ commit }, withdrawalData) {
    // 提交一个comutation请求
    StorageUtil.saveWithdrawalData(withdrawalData);
    commit("SETWITHDRAWALDATA", { withdrawalData }); // 传递给mutation的是一个包含数据的对象
  },
  setTransferData({ commit }, transferData) {
    // 提交一个comutation请求
    StorageUtil.saveTransferData(transferData);
    commit("SETTRANSFERDATA", { transferData }); // 传递给mutation的是一个包含数据的对象
  },
  setGts2CustomerId({ commit }, gts2CustomerId) {
    // 提交一个comutation请求
    StorageUtil.saveGts2CustomerId(gts2CustomerId);
    commit("SETGTS2CUSTOMERID", { gts2CustomerId }); // 传递给mutation的是一个包含数据的对象
  },
  setGts2AccountId({ commit }, gts2AccountId) {
    // 提交一个comutation请求
    StorageUtil.saveGts2AccountId(gts2AccountId);
    commit("SETGTS2ACCOUNTID", { gts2AccountId }); // 传递给mutation的是一个包含数据的对象
  },
  setTabIndex({ commit }, tabIndex) {
    // 提交一个comutation请求
    StorageUtil.saveTabIndex(tabIndex);
    commit("SETTABINDEX", { tabIndex }); // 传递给mutation的是一个包含数据的对象
  },
  setTimeData({ commit }, timeData) {
    // 提交一个comutation请求
    StorageUtil.saveTimeData(timeData);
    commit("SETTIMEDATA", { timeData }); // 传递给mutation的是一个包含数据的对象
  },
  setPaySwitchStatus({ commit }, paySwitchStatus) {
    // 提交一个comutation请求
    StorageUtil.savePaySwitchStatus(paySwitchStatus);
    commit("SETPAYSWITCHSTATUS", { paySwitchStatus }); // 传递给mutation的是一个包含数据的对象
  },
  setTradeCondition({ commit }, tradeCondition) {
    // 提交一个comutation请求
    StorageUtil.saveTradeCondition(tradeCondition);
    commit("SETTRADECONDITION", { tradeCondition }); // 传递给mutation的是一个包含数据的对象
  },
  setEntrustCondition({ commit }, entrustCondition) {
    // 提交一个comutation请求
    StorageUtil.saveEntrustCondition(entrustCondition);
    commit("SETENTRUSTCONDITION", { entrustCondition }); // 传递给mutation的是一个包含数据的对象
  },
  setProfitAndLossCondition({ commit }, profitAndLossCondition) {
    // 提交一个comutation请求
    StorageUtil.saveProfitAndLossCondition(profitAndLossCondition);
    commit("SETPROFITANDLOSSCONDITION", { profitAndLossCondition }); // 传递给mutation的是一个包含数据的对象
  },
  setCreditCondition({ commit }, creditCondition) {
    // 提交一个comutation请求
    StorageUtil.saveCreditCondition(creditCondition);
    commit("SETCREDITCONDITION", { creditCondition }); // 传递给mutation的是一个包含数据的对象
  },
  setStopCondition({ commit }, stopCondition) {
    // 提交一个comutation请求
    StorageUtil.saveStopCondition(stopCondition);
    commit("SETSTOPCONDITION", { stopCondition }); // 传递给mutation的是一个包含数据的对象
  },
  setKeepAlive({ commit }, keepAlive) {
    // 提交一个comutation请求
    StorageUtil.saveKeepAlive(keepAlive);
    commit("SETKEEPALIVE", { keepAlive }); // 传递给mutation的是一个包含数据的对象
  },
  setTickData({ commit }, tickData) {
    // 提交一个comutation请求
    StorageUtil.saveTickData(tickData);
    commit("SETTICKDATA", { tickData }); // 传递给mutation的是一个包含数据的对象
  },
};
